import { Location } from 'src/modules/routing/types/Location';
import { TransitionTarget } from 'src/modules/routing/types/TransitionTarget';
import { createActions } from 'src/utils/createActions';

type RouteChangeRequestData = {
  readonly location: Location;
};

export const ROUTE_CHANGE = createActions<RouteChangeRequestData, TransitionTarget>('ROUTE_CHANGE');
